import { initWishlistTooltip } from "./wishlist-tooltip.js";

export function initTrendingTabs() {
  const tabContainer = document.querySelector('.trending-tabs');
  const grid = document.querySelector('.trending-products-grid');

  if (!tabContainer || !grid) return;

  const buttons = Array.from(tabContainer.querySelectorAll('[data-type]'));
  let isLoading = false;

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (isLoading || btn.classList.contains('is-active')) return;
      isLoading = true;

      const type = btn.dataset.type;

      buttons.forEach((b) => {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');

      grid.classList.add('is-loading');

      const formData = new FormData();
      formData.append('action', 'serawai_trending_products');
      formData.append('nonce', serawai_ajax.nonce);
      formData.append('type', type);

      fetch(serawai_ajax.url, {
        method: 'POST',
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success && data.data.html) {
            grid.innerHTML = data.data.html;
            grid.dataset.type = type;
            initWishlistTooltip(grid);
          }
        })
        .catch(() => {
          // Silently fail
        })
        .finally(() => {
          grid.classList.remove('is-loading');
          isLoading = false;
        });
    });
  });
}
